import { RouteObject } from 'react-router-dom';
import { MaintenanceGuard } from '../MaintenanceGuard';
import SelectRole from '../pages/login/SelectRole';
import { HFNAuth } from '../pages/hfnauth';
import {
	ROOT,
	LOGIN,
	HFN_AUTH_AUTHORIZATION,
	SELECT_ROLE,
} from '../shared/Routes';
import { SelfRegistrationRole } from '../pages/functionary/SelfRegistration/SelfRegistrationRole';

export const RootRoutes: RouteObject[] = [
	{ path: HFN_AUTH_AUTHORIZATION, element: <HFNAuth /> },
	{ path: ROOT, element: <MaintenanceGuard component={<SelectRole />} /> },
	{ path: LOGIN, element: <MaintenanceGuard component={<SelectRole />} /> },
	{
		path: SELECT_ROLE,
		element: <MaintenanceGuard component={<SelfRegistrationRole />} />,
	},
];
